var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('SideMenu'),_c('v-main',{style:({
      'margin-left': '240px',
      'background-color': '#f1f2f8',
      'min-height': '100vh',
    })},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }